import { render, staticRenderFns } from "./lanhai.vue?vue&type=template&id=4a0e65fc&scoped=true&"
import script from "./lanhai.vue?vue&type=script&lang=js&"
export * from "./lanhai.vue?vue&type=script&lang=js&"
import style0 from "./lanhai.vue?vue&type=style&index=0&id=4a0e65fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e65fc",
  null
  
)

export default component.exports